import {
  UPDATE_USER_SETTINGS_ACTION,
  UPDATE_USER_SETTINGS_FAILED,
  UPDATE_USER_SETTINGS_KEY,
  UPDATE_USER_SETTINGS_SUCCESS,
} from 'src/redux/constants';
import type { ViewAction, ViewActionPayload } from 'src/redux/viewState/types';

export const updateUserSettings = (
  settingsData: ViewActionPayload,
): ViewAction => {
  return {
    type: UPDATE_USER_SETTINGS_ACTION,
    dataKey: UPDATE_USER_SETTINGS_KEY,
    payload: settingsData,
  };
};

export const updateUserSettingsSuccess = (
  updatedData: ViewActionPayload,
): ViewAction => {
  return {
    type: UPDATE_USER_SETTINGS_SUCCESS,
    payload: updatedData,
  };
};

export const updateUserSettingsFailed = (
  error: ViewActionPayload,
): ViewAction => {
  return {
    type: UPDATE_USER_SETTINGS_FAILED,
    payload: error,
  };
};
